<template>
  <div class="express">
    <div class="express-header">
      <span class="express-header-info">运单号 {{ express.code }}</span>
      <van-button
        type="primary"
        color="#1DB475"
        icon-prefix="iconfont"
        icon="fenxiang"
        @click="$emit('pick-up', express)"
      >
        取件
      </van-button>
    </div>
    <div class="express-meta">
      <div class="meta-item">
        <span class="meta-item-label">格子编号：</span>
        <span class="meta-item-cont">{{ express.cabinet.serial }}</span>
      </div>
      <div class="line"></div>
      <div class="meta-item">
        <span class="meta-item-label">电话：</span>
        <span class="meta-item-cont">{{ express.phone }}</span>
      </div>
      <div class="line"></div>
      <div class="meta-item">
        <span class="meta-item-label">取件码：</span>
        <span class="meta-item-cont">{{ express.secret }}</span>
      </div>
      <div class="line"></div>
      <div class="meta-item">
        <span class="meta-item-label">入站时间：</span>
        <span class="meta-item-cont">{{ express.intime }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    express: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },

  methods: {},
  created() {}
};
</script>

<style lang="scss">
.express {
  box-shadow: 0px 6px 30px 0px rgba(29, 180, 117, 0.08);
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f2f4f7;
    padding: 14px 20px;

    &-info {
      font-size: rem(24);
    }
  }

  &-meta {
    background-color: $white-color;
    padding: 14px 20px;
    font-size: rem(20);
    display: flex;
    justify-content: space-between;
    .line {
      width: 1px;
      background: #909599;
    }
  }

  .meta-item {
    line-height: 1;
    &-label {
      color: #909599;
    }

    &-cont {
      color: #000000;
    }
  }
}
</style>
